export default "__VITE_ASSET__j3_2CF6P__"